(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[798],{

/***/ 33901:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/[page]",
      function () {
        return __webpack_require__(36898);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2908:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Purple Booth Mark.555a1209.svg","height":620,"width":820});

/***/ }),

/***/ 92152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _nav_full_LogoHeader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29727);


var Spinner = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        "data-testid": "Spinner",
        className: "prose flex h-screen min-w-full items-center justify-center transition-all delay-100 duration-150 ease-in-out motion-safe:animate-spin dark:prose-invert",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nav_full_LogoHeader__WEBPACK_IMPORTED_MODULE_1__/* .LogoHeader */ .S, {})
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Spinner);


/***/ }),

/***/ 97786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ index_IndexItem; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js + 2 modules
var parseISO = __webpack_require__(19288);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/index/IndexItemTitle.tsx
var IndexItemTitle = __webpack_require__(96250);
;// CONCATENATED MODULE: ./components/index/IndexItemLinkTitle.tsx



var IndexItemLinkTitle = function(param) {
    var title = param.title, href = param.href, pageHasTitle = param.pageHasTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        passHref: true,
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            "data-testid": "IndexItemLinkTitle",
            className: "no-underline hover:underline",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IndexItemTitle/* IndexItemTitle */.l, {
                title: title,
                pageHasTitle: pageHasTitle
            })
        })
    });
};

// EXTERNAL MODULE: ./components/index/IndexItemStatsLine.tsx
var IndexItemStatsLine = __webpack_require__(48988);
// EXTERNAL MODULE: ./components/index/IndexItemCategories.tsx
var IndexItemCategories = __webpack_require__(61053);
;// CONCATENATED MODULE: ./components/index/IndexItemArrowButton.tsx


var IndexItemArrowButton = function(param) {
    var href = param.href, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        passHref: true,
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            "data-testid": "IndexItemArrowButton a",
            className: "block p-1 no-underline",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "hover:underline",
                    children: children
                }),
                " \u2192"
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/index/IndexItem.tsx






var IndexItem = function(param) {
    var articleMeta = param.articleMeta, pageHasTitle = param.pageHasTitle;
    var articleDate = articleMeta.date ? (0,parseISO/* default */.Z)(articleMeta.date) : undefined;
    var yearParam = encodeURIComponent((articleDate === null || articleDate === void 0 ? void 0 : articleDate.getFullYear()) || "");
    var monthParam = encodeURIComponent((articleDate === null || articleDate === void 0 ? void 0 : articleDate.getMonth()) || "");
    var dayParam = encodeURIComponent((articleDate === null || articleDate === void 0 ? void 0 : articleDate.getDate()) || "");
    var slugParam = encodeURIComponent(articleMeta.slug);
    var url = "/blog/".concat(yearParam, "/").concat(monthParam, "/").concat(dayParam, "/").concat(slugParam);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: "mb-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IndexItemLinkTitle, {
                title: articleMeta.title,
                href: url,
                pageHasTitle: pageHasTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IndexItemStatsLine/* IndexItemStatsLine */.Z, {
                readLengthMin: articleMeta.readLengthMin,
                date: articleDate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IndexItemCategories/* IndexItemCategories */.K, {
                categories: articleMeta.categories
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "prose my-2 dark:prose-invert",
                children: articleMeta.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IndexItemArrowButton, {
                href: url,
                children: "Read On"
            })
        ]
    });
};
/* harmony default export */ var index_IndexItem = (IndexItem);


/***/ }),

/***/ 61053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ IndexItemCategories; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


var IndexItemCategories = function(param) {
    var categories = param.categories;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: "flex list-none flex-row flex-wrap gap-1 pl-0 font-bold",
        children: categories.map(function(tag, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: "m-0 inline-block whitespace-nowrap rounded bg-slate-100 p-1 dark:bg-slate-900",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: "/categories/".concat(encodeURIComponent(tag.toLowerCase()), "/"),
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        "data-testid": "IndexItemCategories ".concat(tag, " a"),
                        className: "font-bold no-underline",
                        children: tag
                    })
                })
            }, tag + index);
        })
    });
};


/***/ }),

/***/ 48988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IndexItemStatsLine; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66003);



var IndexItemStatsLine = function(param) {
    var readLengthMin = param.readLengthMin, date = param.date;
    var timestamp = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return new Intl.NumberFormat(undefined, {
            style: "unit",
            unit: "minute"
        }).format(readLengthMin);
    }, [
        readLengthMin
    ]);
    var formattedDate = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return date ? (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(date) + " \xb7 " : "";
    }, [
        date
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        "data-testid": "IndexItemStatsLine",
        className: "text-slate-600 dark:text-slate-400",
        children: [
            formattedDate,
            " ",
            timestamp,
            " read"
        ]
    });
};


/***/ }),

/***/ 96250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ IndexItemTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Heading2 = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
        "data-testid": "IndexItemTitle h2",
        className: "mb-1",
        children: children
    });
};
var Heading1 = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
        "data-testid": "IndexItemTitle h1",
        className: "mb-1",
        children: children
    });
};
var IndexItemTitle = function(param) {
    var title = param.title, pageHasTitle = param.pageHasTitle;
    if (pageHasTitle) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Heading2, {
            children: title
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Heading1, {
        children: title
    });
};


/***/ }),

/***/ 29727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ LogoHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/Purple Booth Logo-01.svg
/* harmony default export */ var Purple_Booth_Logo_01 = ({"src":"/_next/static/media/Purple Booth Logo-01.f744b19e.svg","height":929,"width":1385});
;// CONCATENATED MODULE: ./components/nav/full/LightLogo.tsx




var LightLogo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        passHref: true,
        href: "/",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            "data-testid": "LightLogo",
            className: "dark:hidden",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                layout: "intrinsic",
                src: Purple_Booth_Logo_01,
                alt: "Purple Booth Ltd.",
                width: "320",
                height: "215",
                unoptimized: true
            })
        })
    });
};

// EXTERNAL MODULE: ./public/Purple Booth Mark.svg
var Purple_Booth_Mark = __webpack_require__(2908);
;// CONCATENATED MODULE: ./components/nav/full/DarkLogo.tsx




var DarkLogo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "m-10 hidden aspect-square items-center justify-center rounded-full bg-slate-100 p-5 dark:flex",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            passHref: true,
            href: "/",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                "data-testid": "DarkLogo",
                className: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    layout: "intrinsic",
                    src: Purple_Booth_Mark/* default */.Z,
                    width: "200",
                    height: "200",
                    alt: "Purple Booth Ltd.",
                    unoptimized: true
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/nav/full/LogoHeader.tsx



var LogoHeader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        "data-testid": "LogoHeader",
        className: "cursor-pointer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LightLogo, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DarkLogo, {})
        ]
    });
};


/***/ }),

/***/ 36898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _page_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/index/IndexItem.tsx + 2 modules
var IndexItem = __webpack_require__(97786);
;// CONCATENATED MODULE: ./components/paginator/DisabledLink.tsx

var DisabledLink = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "m-2",
        children: children
    });
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/paginator/ActiveLink.tsx


var ActiveLink = function(param) {
    var children = param.children, page = param.page, selected = param.selected;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: page == 1 ? "/" : "/page/".concat(encodeURIComponent(page)),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            "data-testid": "ActiveLink",
            className: "p-2 hover:bg-slate-100 dark:hover:bg-slate-900 ".concat(selected ? " bg-slate-100 dark:bg-slate-900" : ""),
            children: children
        })
    });
};

;// CONCATENATED MODULE: ./components/paginator/PageLink.tsx



var PageLink = function(param) {
    var disabled = param.disabled, page = param.page, children = param.children, selected = param.selected;
    if (disabled) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DisabledLink, {
            children: children
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveLink, {
        page: page,
        selected: selected,
        children: children
    });
};

;// CONCATENATED MODULE: ./components/paginator/Paginator.tsx


var Paginator = function(param) {
    var page = param.page, maxPage = param.maxPage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
        className: "rounded-slate-600 dark:rounded-slate-400 mt-4 inline-flex rounded border",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLink, {
                page: 1,
                disabled: page == 1,
                children: "\xab\xab"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLink, {
                page: page - 1,
                disabled: page == 1,
                children: "\xab"
            }),
            maxPage == page && page > 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLink, {
                page: page - 3,
                children: page - 3
            }),
            page > 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLink, {
                page: page - 2,
                children: page - 2
            }),
            page > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLink, {
                page: page - 1,
                children: page - 1
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLink, {
                selected: true,
                page: page,
                children: page
            }),
            page + 1 <= maxPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLink, {
                page: page + 1,
                children: page + 1
            }),
            page + 2 <= maxPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLink, {
                page: page + 2,
                children: page + 2
            }),
            page + 3 <= maxPage && page == 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLink, {
                page: page + 3,
                children: page + 3
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLink, {
                disabled: page == maxPage,
                page: page + 1,
                children: "\xbb"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLink, {
                disabled: page == maxPage,
                page: maxPage,
                children: "\xbb\xbb"
            })
        ]
    });
};
/* harmony default export */ var paginator_Paginator = (Paginator);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/Spinner.tsx
var Spinner = __webpack_require__(92152);
;// CONCATENATED MODULE: ./pages/page/[page].page.tsx





var Layout = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(947), __webpack_require__.e(641)]).then(__webpack_require__.bind(__webpack_require__, 1641));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1641)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {});
    }
});
var BlogPage = function(param) {
    var meta = param.meta, page = param.page, maxPage = param.maxPage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout, {
        children: [
            meta && meta.map(function(meta, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IndexItem/* default */.Z, {
                    articleMeta: meta
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(paginator_Paginator, {
                page: page,
                maxPage: maxPage
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _page_page = (BlogPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,406,774,888,179], function() { return __webpack_exec__(33901); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);